export const Name = 'personal-product-list';
export const PersonalProductList = Name;
export let PersonalProductListAction = /*#__PURE__*/function (PersonalProductListAction) {
  PersonalProductListAction["Create"] = "create";
  PersonalProductListAction["Update"] = "update";
  PersonalProductListAction["Delete"] = "delete";
  return PersonalProductListAction;
}({});
export let PersonalProductListType = /*#__PURE__*/function (PersonalProductListType) {
  PersonalProductListType["Personal"] = "personal";
  PersonalProductListType["Private"] = "private";
  return PersonalProductListType;
}({});
//# sourceMappingURL=index.js.map